// extracted by mini-css-extract-plugin
module.exports = {"container":"PolicySectionHeading_container__T0_tO","heading":"PolicySectionHeading_heading__41N3j"};